import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=512cf778"
import script from "./YouTube.vue?vue&type=script&lang=ts"
export * from "./YouTube.vue?vue&type=script&lang=ts"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=512cf778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports